import React from "react";
import { FaFacebook } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Row } from "reactstrap";

const SocialShare = () => {
  const selectedCard = useSelector((state) => state.bwvData.selectedService);
  const shareOnFacebook = () => {
    if (!selectedCard?.Id) {
      toast.error("Unable to share: Vendor details not available");
      return;
    }
    const urlToShare = encodeURIComponent(
      `${process.env.REACT_APP_URL}/home#/vendordetails/${selectedCard?.Id}`
    );
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${urlToShare}`,
      "_blank",
      "width=600,height=400"
    );
  };
  return (
    <Row className="mt-1">
      <p>
        <b>Share</b>
      </p>
      <Row className="mt-1">
        <p>
          <b>Share</b>
        </p>
        <div>
          <ul className="m-0">
            <li>
              <button
                onClick={shareOnFacebook}
                style={{
                  fontSize: "22px",
                  border: "none",
                  background: "none",
                }}
                title="Share on Facebook"
              >
                <FaFacebook />
              </button>
              <a
                onClick={() => {
                  const urlToCopy = `${process.env.REACT_APP_URL}/?fbclid=socialLink#/vendordetails/${selectedCard.Id}`;
                  navigator.clipboard
                    .writeText(urlToCopy)
                    .then(() => {
                      toast.success("URL copied to clipboard!");
                    })
                    .catch((err) => {
                      toast.error("Failed to copy URL");
                      console.error("Error copying URL:", err);
                    });
                }}
                style={{
                  cursor: "pointer",
                  border: "none",
                  background: "none",
                  marginLeft: "10px",
                }}
              >
                Copy
              </a>
            </li>
            {/* <li>
              <button
                onClick={() => {
                  const urlToCopy = `${process.env.REACT_APP_URL}/?fbclid=socialLink#/vendordetails/${selectedCard.Id}`;
                  navigator.clipboard
                    .writeText(urlToCopy)
                    .then(() => {
                      toast.success("URL copied to clipboard!");
                    })
                    .catch((err) => {
                      toast.error("Failed to copy URL");
                      console.error("Error copying URL:", err);
                    });
                }}
                style={{
                  fontSize: "22px",
                  border: "none",
                  background: "none",
                }}
                title="Copy URL"
              >
                Copy
              </button>
            </li> */}
          </ul>
        </div>
      </Row>
    </Row>
  );
};

export default SocialShare;
